import api from "../api";
import { API_URL } from "../constants";

export const githubAppApi = {
  getInstallationURL: async (data: { userId: string }) => {
    const response = await api.post(`${API_URL}/v1/github/install`, {
      firebaseUid: data.userId,
    });
    return response.data;
  },

  getInstallations: async () => {
    const response = await api.get(`${API_URL}/v1/github/installations`);
    return response.data;
  },
  getBranches: async (repoName: string, installationId: number) => {
    const response = await api.get(
      `${API_URL}/v1/github/branches?repoName=${repoName}&installationId=${installationId}`,
    );
    return response.data;
  },
};
